var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.items.length
    ? _c(
        "div",
        {
          staticClass: "lpu-photos",
          class: { "mx-n2": _setup.isMobile },
          attrs: { "data-qa": "lpu_photos" },
        },
        [
          _c(_setup.LpuPhotosDialog, {
            ref: "lightboxRef",
            attrs: { items: _setup.items },
          }),
          _vm._v(" "),
          _setup.isMobile
            ? _c(_setup.CoreSwiper, {
                staticClass: "px-2",
                attrs: {
                  "slides-per-view": "auto",
                  "space-between": 8,
                  "has-pagination": false,
                  "has-navigation": false,
                  "placeholder-min-height": 192,
                  "free-mode": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "slides",
                      fn: function ({ slideAttrs }) {
                        return _vm._l(_setup.items, function (item, index) {
                          return _c(
                            "div",
                            _vm._b(
                              { key: `${item.id ?? item.src}-${index}` },
                              "div",
                              slideAttrs,
                              false
                            ),
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "lpu-photos__slide",
                                  attrs: {
                                    type: "button",
                                    "data-qa": "lpu_photos_tile",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _setup.open(index)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "lpu-photos__image",
                                    attrs: {
                                      src: item.src,
                                      alt: item.alt || "",
                                      title: item.title || undefined,
                                      loading: "lazy",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  838149603
                ),
              })
            : _c(
                "div",
                {
                  staticClass: "lpu-photos__mosaic",
                  class: {
                    "lpu-photos__mosaic--cols-1": _setup.mosaicItems.length < 2,
                    "lpu-photos__mosaic--cols-2":
                      _setup.mosaicItems.length === 2,
                    "lpu-photos__mosaic--cols-3":
                      _setup.mosaicItems.length === 3,
                    "lpu-photos__mosaic--cols-4":
                      _setup.mosaicItems.length === 4,
                    "lpu-photos__mosaic--cols-5": _setup.mosaicItems.length > 4,
                  },
                },
                _vm._l(_setup.mosaicItems, function (item, index) {
                  return _c(
                    "button",
                    {
                      key: `${item.id ?? item.src}-${index}`,
                      staticClass: "lpu-photos__tile",
                      class: {
                        "lpu-photos__tile--tall": _setup.isTallTile(index),
                        "lpu-photos__tile--wide": _setup.isWideTile(index),
                      },
                      attrs: { type: "button", "data-qa": "lpu_photos_tile" },
                      on: {
                        click: function ($event) {
                          return _setup.open(index)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "lpu-photos__image",
                        attrs: {
                          src: item.src,
                          alt: item.alt || "",
                          title: item.title || undefined,
                          loading: "lazy",
                        },
                      }),
                      _vm._v(" "),
                      index === _setup.mosaicItems.length - 1 &&
                      _setup.hasMoreOverlay
                        ? _c(
                            "span",
                            {
                              staticClass: "lpu-photos__more text-center",
                              attrs: { "data-qa": "lpu_photos_more" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "lpu-photos__more-count" },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_setup.moreCount) +
                                      "\n        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-body-1" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_setup.tStatic("фото")) +
                                    "\n        "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }